import React, { FC } from 'react';
import { LdapPermissions } from 'app/types';
import { Icon } from '@credativ/plutono-ui';

interface Props {
  permissions: LdapPermissions;
}

export const LdapUserPermissions: FC<Props> = ({ permissions }) => {
  return (
    <div className="gf-form-group">
      <div className="gf-form">
        <table className="filter-table form-inline">
          <thead>
            <tr>
              <th colSpan={1}>Permissions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="width-16"> Plutono admin</td>
              <td>
                {permissions.isPlutonoAdmin ? (
                  <>
                    <Icon name="shield" /> Yes
                  </>
                ) : (
                  'No'
                )}
              </td>
            </tr>
            <tr>
              <td className="width-16">Status</td>
              <td>
                {permissions.isDisabled ? (
                  <>
                    <Icon name="times" /> Inactive
                  </>
                ) : (
                  <>
                    <Icon name="check" /> Active
                  </>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
